import styled from "styled-components";
import PropTypes from "prop-types";
import { useUser } from "../features/authentication/useUser";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useIsAdmin } from "../features/authentication/useIsAdmin";

const FullPage = styled.div`
    height: 100vh;
    background-color: var(--color-grey-50);
    display: flex;
    align-items: center;
    justify-content: center;
`;

function AdminProtectedRoute({ children }) {
    const navigate = useNavigate();
    // 1. Load the authenticated user
    const { isLoading, isAuthenticated, user } = useUser();
    const { isAdmin, isLoading: isAdminLoading } = useIsAdmin(user?.id);

    // 2. if no authenticated user, redirect to homr
    useEffect(
        function () {
            if (!isLoading && !isAdminLoading && (!isAuthenticated || !isAdmin))
                navigate("/");
        },
        [isAuthenticated, isLoading, isAdminLoading, isAdmin, navigate],
    );

    // 3. While loading, show a spinner
    if (isLoading || isAdminLoading)
        return (
            <FullPage>
                <Spinner />
            </FullPage>
        );

    // 4. If there is a user, render the app
    return children;
}

AdminProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AdminProtectedRoute;
